export enum TaskStatus {
    None = 'None',
    Complete="Complete"
}